import React, { useEffect, useState } from 'react';
import { useAuthStore, api } from '../store';
import { translations } from '../translations';

export default function TransactionsPage() {
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(true);
  const { language } = useAuthStore();
  const t = translations[language];

  useEffect(() => {
    const fetchTransactions = async () => {
      try {
        // Placeholder - actualizar cuando el endpoint esté disponible
        setTransactions([]);
      } catch (error) {
        console.error('Error fetching transactions:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchTransactions();
  }, []);

  return (
    <div className="max-w-7xl mx-auto px-4 py-8 dark:text-gray-100">
      <h1 className="text-4xl font-bold mb-8 dark:text-white">{t.transactionsTitle}</h1>

      <div className="bg-white dark:bg-gray-800 rounded-lg shadow overflow-hidden">
        <table className="w-full">
          <thead className="bg-gray-100 dark:bg-gray-700">
            <tr>
              <th className="px-6 py-4 text-left text-sm font-semibold dark:text-gray-200">{t.order}</th>
              <th className="px-6 py-4 text-left text-sm font-semibold dark:text-gray-200">{t.service}</th>
              <th className="px-6 py-4 text-left text-sm font-semibold dark:text-gray-200">{t.status}</th>
              <th className="px-6 py-4 text-left text-sm font-semibold dark:text-gray-200">{t.amount}</th>
              <th className="px-6 py-4 text-left text-sm font-semibold dark:text-gray-200">{t.date}</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200 dark:divide-gray-700">
            {transactions.length === 0 ? (
              <tr>
                <td colSpan="5" className="px-6 py-8 text-center text-gray-500 dark:text-gray-400">
                  {t.noTransactions}
                </td>
              </tr>
            ) : (
              transactions.map((tx) => (
                <tr key={tx.id} className="border-t hover:bg-gray-50 dark:border-gray-700 dark:hover:bg-gray-700/50">
                  <td className="px-6 py-4 dark:text-gray-300">{tx.order_number}</td>
                  <td className="px-6 py-4 dark:text-gray-300">{tx.service_name}</td>
                  <td className="px-6 py-4">
                    <span className={`inline-block px-3 py-1 rounded-full text-xs font-semibold ${
                      tx.status === 'ACCEPTED' ? 'bg-green-100 text-green-800 dark:bg-green-900/40 dark:text-green-300' :
                      tx.status === 'REJECTED' ? 'bg-red-100 text-red-800 dark:bg-red-900/40 dark:text-red-300' :
                      'bg-yellow-100 text-yellow-800 dark:bg-yellow-900/40 dark:text-yellow-300'
                    }`}>
                      {tx.status}
                    </span>
                  </td>
                  <td className="px-6 py-4 dark:text-gray-300">${tx.amount}</td>
                  <td className="px-6 py-4 dark:text-gray-300">{new Date(tx.created_at).toLocaleDateString()}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

